import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import { Module } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import { MODULES_COLUMN_ID } from "../constants";
import useCellCopyAction from "../useCellCopyAction";

const ModulesTableCreatedAtCell = ({
  item: module,
  ...cellProps
}: TableSimpleCellProps<Module>) => {
  const copyAction = useCellCopyAction({
    column: MODULES_COLUMN_ID.CREATED_AT,
    text: makeTimestampToCopy(module.createdAt),
  });

  const isEmpty = !module.createdAt;

  const actions = useMemo(() => (isEmpty ? undefined : [copyAction]), [copyAction, isEmpty]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}
      {!isEmpty && <Timestamp timestamp={module.createdAt} />}
    </TableSimpleCell>
  );
};

export default ModulesTableCreatedAtCell;
